import { Descope } from '@descope/react-sdk';

interface DescopeSignInProps {
    flowId: string;
    onAuthenticated: (_descopeToken: string | null) => void;
    onError: (_errorMessage: string) => void;
    isVisible?: boolean;
}

const getDescopeTokenFromEvent = (event: unknown): string | null => {
    const detail = (event as { detail?: Record<string, unknown> })?.detail ?? {};
    const candidates = [
        detail?.sessionJwt,
        detail?.accessToken,
        detail?.jwt,
        (detail?.sessionToken as Record<string, unknown>)?.jwt,
        detail?.sessionToken,
    ];
    const token = candidates.find((candidate) => typeof candidate === 'string' && candidate.length > 0);
    return (token as string) ?? null;
};

export const DescopeSignIn = ({ flowId, onAuthenticated, onError, isVisible = true }: DescopeSignInProps) => {
    const wrapperClassName = `descope-sign-in-wrapper${isVisible ? '' : ' descope-sign-in-wrapper--preload'}`;

    return (
        <div className={wrapperClassName} aria-hidden={!isVisible}>
            <Descope
                flowId={flowId}
                theme="dark"
                onSuccess={(event: unknown) => {
                    const token = getDescopeTokenFromEvent(event);
                    onAuthenticated(token);
                }}
                onError={(error: unknown) => {
                    const errorMessage = (error as { detail?: { message?: string } })?.detail?.message;
                    onError(errorMessage || 'Descope authentication failed.');
                }}
            />
        </div>
    );
};
